"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _events = _interopRequireDefault(require("events"));
var _loggerProxy = _interopRequireDefault(require("../logs/logger-proxy"));
var _loggerConfig = _interopRequireDefault(require("../logs/logger-config"));
var _util = _interopRequireDefault(require("./util"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Events
 * plugin-meetings local
 * Used to emit events internally between modules specific to an object
 */
var EventsScope = /*#__PURE__*/function (_ChildEmitter) {
  (0, _inherits2.default)(EventsScope, _ChildEmitter);
  var _super = _createSuper(EventsScope);
  function EventsScope() {
    (0, _classCallCheck2.default)(this, EventsScope);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(EventsScope, [{
    key: "emit",
    value:
    /**
     * Emits and logs an event
     * @param {*} scope
     * @param {*} eventName
     * @param {*} args
     * @returns {Function}
     */
    function emit(scope, eventName, args) {
      _loggerProxy.default.logger.debug("".concat(_util.default.getScopeLog(scope), "event#").concat(eventName).concat(_loggerConfig.default.verboseEvents ? " -- ".concat(_util.default.getEventLog(args)) : ''));
      return (0, _get2.default)((0, _getPrototypeOf2.default)(EventsScope.prototype), "emit", this).call(this, eventName, args);
    }
  }]);
  return EventsScope;
}(_events.default);
exports.default = EventsScope;
//# sourceMappingURL=events-scope.js.map
